import {EventEmitter} from "events";

class LoadingStore extends EventEmitter {
	constructor() {
		super();
		this.loading = false;
	}
	getState () {
		return this.loading;
	}
	startLoading () {
		this.loading = true;
		this.emit("change");
	}
	stopLoading () {
		this.loading = false;
		this.emit("change");
	}
}



const loadingStore = new LoadingStore();

loadingStore.setMaxListeners(0);

export default loadingStore;


/** WEBPACK FOOTER **
 ** ./src/stores/LoadingStore.js
 **/